const globalMixin = {
	methods: {
		cdn(url){
			url = url.replace('@cdn', this.$common.cdnUrl)
			url = url.replace('@oss', this.$common.ossUrl)
			return url
		}
	},
}
export default globalMixin